/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SendNextAppointmentReminder/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function SendNextAppointmentReminder({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Email/NewEmail/Content/Content/Form/SendNextAppointmentReminder"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let globalFeatureFlagsIsAutomationHubCommsEnabledValueData = fromData.useDataFormat({ viewPath,
context: 'global',
path: 'feature_flags.is_automation_hub_comms_enabled',
format: fromFormat.not,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(globalFeatureFlagsIsAutomationHubCommsEnabledValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}